var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpportunitiesNavIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.5 7.5c1.2 2.1 4.2 3.3 7.5 3.3s6.3-1.2 7.5-3.3M6 7.2h12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 7.2s.9 3.6 6 8.1V19c0 .6.4 1 1 1h.9c.6 0 1-.4 1-1v-3.7c5.1-4.5 6-8.1 6-8.1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.2,
  cy: 6.2,
  r: 2.2
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.8 7.8 1.4 1.4M12.6 4.4l.3.8.8.3-.8.3-.3.8-.3-.8-.8-.3.8-.3zM14.9 5.4l.2.5.5.2-.5.2-.2.5-.2-.5-.5-.2.5-.2zM7.2 18.6v1.8M5.4 18.2c0 .7 1 1.3 2.3 1.3s2.3-.6 2.3-1.3-1-1.3-2.3-1.3-2.3.6-2.3 1.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.4 18.2v1.2c0 .7 1 1.3 2.3 1.3s2.3-.6 2.3-1.3v-1.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.6,
  cy: 18.2,
  r: 2.8
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.6 18.2.7.7 1.6-1.6"
}))));
export { SvgOpportunitiesNavIcon as ReactComponent };
export default __webpack_public_path__ + "133c1e9b79151e4d929efcef97715e4e.svg";